"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumerNavItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const useLinkWithWcid_1 = __importDefault(require("../../hooks/useLinkWithWcid"));
const NewIcon_1 = require("../icons/NewIcon");
const ConsumerNavItem_module_css_1 = __importDefault(require("./ConsumerNavItem.module.css"));
/**
 * Individual Nav Item rendered as part of ConsumerNav
 */
function ConsumerNavItem(props) {
    const { item, active } = props;
    const { label, title, link, Icon, isNew, openInNewTab } = item;
    const href = (0, useLinkWithWcid_1.default)(link);
    return ((0, jsx_runtime_1.jsx)("a", { href: href, "aria-label": label, className: (0, clsx_1.default)(ConsumerNavItem_module_css_1.default.link, { [ConsumerNavItem_module_css_1.default.activeLink]: active }), onClick: (event) => props.onClick(event, item), target: openInNewTab ? "_blank" : "", rel: "noopener", "data-testid": `navItem-${label}`, children: (0, jsx_runtime_1.jsxs)("span", { className: ConsumerNavItem_module_css_1.default.content, children: [isNew && ((0, jsx_runtime_1.jsx)("span", { className: ConsumerNavItem_module_css_1.default.newicon, children: (0, jsx_runtime_1.jsx)(NewIcon_1.NewIcon, {}) })), (0, jsx_runtime_1.jsx)("span", { className: ConsumerNavItem_module_css_1.default.icon, children: (0, jsx_runtime_1.jsx)(Icon, { active: active }) }), (0, jsx_runtime_1.jsx)("span", { className: ConsumerNavItem_module_css_1.default.text, children: title })] }) }));
}
exports.ConsumerNavItem = ConsumerNavItem;
//# sourceMappingURL=ConsumerNavItem.js.map